import { put, takeEvery } from "redux-saga/effects";
import { GET_BRANDS, GET_CATEGORIES, GET_PRODUCTS, GET_SUB_CATEGORIES, GET_SWIPPED, SET_BRANDS, SET_CATEGORIES, SET_SUB_CATEGORIES, SET_SWIPPED } from "../ConstAction";
import CategoriesApiRequests from "../../Services/Categories";


function* getCategories(data) {
    try {
        let response = yield CategoriesApiRequests.requestcategories(data.data);

        yield put({
            type: SET_CATEGORIES,
            response,
        })

        // data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getsubCategories(data) {

    try {
        let response = yield CategoriesApiRequests.requestsubcategories(data.data);

        yield put({
            type: GET_PRODUCTS,
            data: { page: 1, ...response.data }
        })

        yield put({
            type: SET_SUB_CATEGORIES,
            response,
        })
        data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}

function* getBrands(data) {
    try {
        let response = yield CategoriesApiRequests.requestbrands(data?.data);
        yield put({
            type: SET_BRANDS,
            response,
        })
        // data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}


function* getswip(data) {
    try {
        yield put({
            type: SET_SWIPPED,
            response: data
        })
        // data.setLoading(false)

    } catch (err) {
        // data.setLoading(false)
    }
}

// Defination of all Saga
function* Categoriessaga() {
    yield takeEvery(GET_CATEGORIES, getCategories);
    yield takeEvery(GET_SUB_CATEGORIES, getsubCategories);
    yield takeEvery(GET_BRANDS, getBrands);
    yield takeEvery(GET_SWIPPED, getswip);
}
export default Categoriessaga;